<template>
  <v-container>
    <v-layout row wrap justify-space-between px-3 pb-3>
      <v-btn
        color="orange"
        class="white--text"
        @click="contactUsForm()"
      >
        Tenho interesse
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="red"
        @click="addOrRemoveFavorite()"
      >
        <v-icon v-if="!immobileFavorite" dark>
          favorite
        </v-icon>
        <v-icon v-else dark>
          favorite_border
        </v-icon>
      </v-btn>
    </v-layout>
    <v-card class="pt-1" color="white" elevation="3">
      <v-carousel>
        <v-carousel-item
          v-for="(item) in immobileImages"
          :key="item.id"
          :src="item.url"
          reverse-transition="fade-transition"
          transition="fade-transition"
          @click="openFullScreenImage(item.url)"
        >
          <v-layout row wrap justify-space-between px-4>
            <v-chip
              label
              color="rgb(0,211,99,1.6)"
              class="white--text"
              normal
            >
              {{ immobileSellOrLocateValue(immobileInfo) }}
            </v-chip>
            <v-chip
              label
              color="rgb(0,211,99,1.6)"
              class="white--text"
              normal
            >
              {{ immobileFinality(immobileInfo.finalidade_imovel) }}
            </v-chip>
          </v-layout>
        </v-carousel-item>
      </v-carousel>
      
      <v-layout v-if="immobileInfo != null" row wrap justify-start px-8>
        <v-flex xs6 sm5 md4 lg2 xl2 class="pt-2">
          <span class="pr-1 font-weight-bold">Código:</span>
          {{ immobileInfo.codigo_imovel }}
        </v-flex>
        <v-flex xs6 sm4 md3 lg2 xl2 class="pt-2">
          <span class="pr-1 font-weight-bold">Tipo:</span>
          {{ immobileType(immobileInfo.tipo_imovel) }}
        </v-flex>
        <v-flex xs12 sm3 md3 lg2 xl2 class="pt-2">
          <span class="pr-1 font-weight-bold">Área privativa: </span>
          {{ immobileInfo.area_privativa }}
        </v-flex>
        <v-flex xs12 sm4 md3 lg2 xl2 class="pt-2">
          <span class="pr-1 font-weight-bold">Área construída: </span>
          {{ immobileInfo.metragem_construida }}
        </v-flex>
        <v-flex xs12 sm4 md3 lg2 xl2 class="pt-2">
          <span class="pr-1 font-weight-bold">Área total: </span>
          {{ immobileInfo.area_total }}
        </v-flex>

        <v-flex xs6 sm4 md3 lg2 xl2 class="pt-2">
          <div class="d-flex align-end">
            <v-icon class="pr-1" >hotel</v-icon>
            <span class="pr-1 font-weight-bold">Dormitórios:</span>
            {{ immobileInfo.total_quartos }}
          </div>
        </v-flex>
        <v-flex xs6 sm4 md3 lg2 xl2 class="pt-2">
          <div class="d-flex align-end">
            <v-icon class="pr-1" >hot_tub</v-icon>
            <span class="pr-1 font-weight-bold">Suítes:</span>
            {{ immobileInfo.total_suites }}
          </div>
        </v-flex>
        <v-flex xs6 sm4 md3 lg2 xl2 class="pt-2">
          <div class="d-flex align-end">
            <v-icon class="pr-1" >drive_eta</v-icon>
            <span class="pr-1 font-weight-bold">Garagens:</span>
            {{ immobileInfo.vaga_garagem_coberta + immobileInfo.vaga_garagem_descoberta }}
          </div>
        </v-flex>
        <v-flex xs6 sm4 md3 lg2 xl2 class="pt-2">
          <div class="d-flex align-end">
            <v-icon class="pr-1" >bathtub</v-icon>
            <span class="pr-1 font-weight-bold">Banheiros:</span>
            {{ immobileInfo.quantidade_banheiros }}
          </div>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl6 class="pt-2">
          <div class="d-flex align-start">
            <span class="pr-1 font-weight-bold">Endereço:</span>
            {{ immobileInfo.rua + ', N ' + immobileInfo.numero + ' - ' + immobileInfo.bairro + ' - ' + immobileInfo.cidade[1] + '/' + immobileInfo.estado[1] + ' CEP: ' + immobileInfo.cep }}
          </div>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12 class="py-6">
          <div v-if="immobileInfo.observacoes">
            <h3 class="pr-1 font-weight-bold">Observações</h3>
            {{ immobileInfo.observacoes }}
          </div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-spacer class="py-6"></v-spacer>
    <v-card v-if="immobileInfo != null" color="white" elevation="3">
      <v-card-title>Características</v-card-title>
      <v-card-text>
        <v-layout row wrap justify-start>
          <div v-for="item in featureKeys" :key="item.id">
            <span v-if="immobileInfo[item.key] == true" class="font-weight-bold pr-3">
                <v-icon>done</v-icon>
                {{ item.label }}
            </span>
          </div>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-spacer class="py-6"></v-spacer>
    <v-card color="white" elevation="3" min-height="400" ref='cardMaps'>
      <v-card-title>Localização</v-card-title>
      <div>
        <v-card-text v-if="shareLinkMaps">
          <iframe 
            :src="shareLinkMaps" 
            frameborder="0" 
            :style="'width:' + cardMapsWidth + 'px;' +  'height:' + cardMapsHeight + 'px'"
            allowfullscreen="" 
            aria-hidden="false" 
            tabindex="0"
          ></iframe>
        </v-card-text>
        <v-card-text v-else>
          <span>Localização não encontrada.</span>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="showImageFullScreen" fullscreen>
      <v-card color="rgb(0,0,0,0.7)">
        <div class="d-flex justify-end">
          <v-btn
            icon
            @click="showImageFullScreen = false"
          >
            <v-icon large color="white">close</v-icon>
          </v-btn>
        </div>
        <v-container>
          <v-img max-width="auto" max-height="auto" :src="actualImage" ></v-img>
        </v-container>
      </v-card>
    </v-dialog>
    <ContactUsForm :open="openContactUsForm" :fillNote="fillNote" @closeContactUsForm="closeContactUsForm()" />
  </v-container>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import apiState from '@/ilios.store'
import ContactUsForm from '@/components/Global/ContactUsForm'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'ImmobileDetailCard',

  props: {
    immobileFavorite: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  components: {
    ContactUsForm,
    VueRecaptcha,
  },

  data: () => ({
    sitekey: '',
    recaptchaVerify: true,
    openContactUsForm: false,
    fillNote: '',
    saveLocation: [],
    immobileTypes: [
      {id: 1, name: 'Casa' },
      {id: 2, name: 'Kitnet' },
      {id: 3, name: 'Sobrado' },
      {id: 4, name: 'Apartamento' },
      {id: 5, name: 'Sobreloja' },
      {id: 6, name: 'Terreno' },
      {id: 7, name: 'Sala' },
      {id: 8, name: 'Loja' }],
    immobileFinalitys: [
      {id: 1, name: 'Venda' },
      {id: 2, name: 'Locação' },
      {id: 3, name: 'Locação/Venda' }],
     positions: [
      {id: 1, name: 'Frente' },
      {id: 2, name: 'Fundo' }],
    liningTypes: [
      {id: 1, name: 'Laje' },
      {id: 2, name: 'Forro' },
      {id: 3, name: 'PVC' }],
    featureKeys: [
      {key: "academia", label: "Academia"}, 
      {key: "cerca_eletrica", label: "Cerca Elétrica"}, 
      {key: "portaria_24_horas", label: "Portaria 24 Horas"}, 
      {key: "piscina", label: "Piscina"}, 
      {key: "jardim_de_inverno", label: "Jardim de Inverno"}, 
      {key: "elevador", label: "Elevador"}, 
      {key: "area_gourmet", label: "Área Gourmet"}, 
      {key: "sala_de_tv", label: "Sala de TV"}, 
      {key: "sala_de_jantar", label: "Sala de Jantar"}, 
      {key: "sala_de_estar", label: "Sala de Estar"}, 
      {key: "sacada", label: "Sacada"}, 
      {key: "despensa", label: "Despensa"}, 
      {key: "copa", label: "Copa"}, 
      {key: "closet", label: "Closet"}, 
      {key: "area_de_servico", label: "Área de Serviço"}],
    
    immobileInfo: null,
    immobileImages: null,
    actualImage: null,
    showImageFullScreen: false,
    cardMapsWidth: 100,
    cardMapsHeight: 100,
    latitude: null,
    longitude: null,
    showGoogleMaps: false,
    shareLinkMaps: null,
  }),

  mounted() {
    this.sitekey = process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY
    
    var immobileId = this.$router.history.current.hash
    immobileId = immobileId.slice(1,immobileId.length)
    this.setImmobileDetail({
      immobileId: immobileId
    })
    this.setMapsSize()
  },

  computed: {
    immobileInfoData(){
      return this.getImmobileDetail()
    },
    immobileImagesData(){
      return this.getimmobileDetailImages()
    },

  },

  watch: {
    immobileInfoData: function(){
      this.immobileInfo = this.immobileInfoData
      if (this.immobileInfoData.share_link_maps != false)
        var el = document.createElement( 'html' );
        el.innerHTML = this.immobileInfoData.share_link_maps
        var tagIframe = el.getElementsByTagName('iframe')
        this.shareLinkMaps = tagIframe[0].src

      if (this.immobileInfo && this.$cookies.isKey(this.immobileInfo.gitcodigo_imovel)){
        this.immobileFavorite = true
      }
    },
    immobileImagesData: function(){
      this.immobileImages = this.immobileImagesData
    },
  },

  methods: {
    ...mapActions({
      setImmobileDetail: 'Immobile/getImmobileDetail',
    }),

    ...mapGetters({
      getImmobileDetail: 'Immobile/getImmobileDetail',
      getimmobileDetailImages: 'Immobile/getimmobileDetailImages',
    }),

    addOrRemoveFavorite(){
      if (!this.immobileFavorite){
        if (!this.$cookies.isKey(this.immobileInfo.codigo_imovel)){
          this.$cookies.set(this.immobileInfo.codigo_imovel, this.immobileInfo)
        }
        this.immobileFavorite = true
      }
      else{
        this.$cookies.remove(this.immobileInfo.codigo_imovel)
        this.immobileFavorite = false
      }
    },

    onVerify: function (response) {
     if (response){
       this.recaptchaVerify = false
     }
    },

    onExpired: function () {
      this.recaptchaVerify = true
    },
    
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    },

    contactUsForm(){
      this.fillNote = 'Olá, tenho interesse no imóvel de número de referência: ' + this.immobileInfo.codigo_imovel + ', localizado em ' + this.immobileInfo.rua + ', N ' + this.immobileInfo.numero + ' - ' + this.immobileInfo.bairro + ' - ' + this.immobileInfo.cidade[1] + '/' + this.immobileInfo.estado[1] + ' CEP: ' + this.immobileInfo.cep + '. Por favor, entre em contato comigo.'
      this.openContactUsForm = true
    },

    closeContactUsForm(){
      this.fillNote = ''
      this.openContactUsForm = false
    },

    immobileType(typeId){
      var result = '---'
      this.immobileTypes.forEach(element => {
        if (element.id == typeId) result = element.name
      });
      return result
    },

    immobileFinality(finalityId){
      var result = '---'
      this.immobileFinalitys.forEach(element => {
        if (element.id == finalityId) result = element.name
      });
      return result
    },

    immobileSellOrLocateValue(objImmobile){
      var result = null
      var immobileTypeId = objImmobile.finalidade_imovel
      switch (immobileTypeId) {
        case 1:
          result = objImmobile.valor_c_doc
          break;
      
        case 2:
          result = objImmobile.valor_aluguel
          break;

        case 3:
          result = objImmobile.valor_c_doc
          break;
      }
      if(!result > 0) result = 'Consulte-nos'
      else result = 'R$ ' + result.toFixed(2)
      
      return result
    },

    openFullScreenImage(url){
      this.actualImage = url
      this.showImageFullScreen = true
    },

    setMapsSize() {
      this.cardMapsWidth = this.$refs.cardMaps.$el.clientWidth - 30
      this.cardMapsHeight = this.$refs.cardMaps.$el.clientHeight - 70
    }
  },
};
</script>